import React, { useState, useEffect } from "react";
import BaseModal from "components/BaseModal";
import { showMainToast } from "utils/showToast";
import { useSession } from "hooks/useSession";

export default function TransferRAmountModal({ show, onClose, mode, userData }) {
  const {userid} = useSession()
  const [errors, setErrors] = useState({});
  const [apiList, setApiList] = useState([]);
  const [comTypes, setComTypes] = useState([]);

  // ✅ Fetch dropdowns (api_id & com_type)
  



  const validateForm = () => {
    const requiredFields = [ "account",  "account_type"];
    let newErrors = {};
    requiredFields.forEach((field) => {
      const value = document.getElementById(field)?.value.trim();
      if (!value) newErrors[field] = `${field} is required.`;
    });
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) {
      showMainToast("Please correct the errors before saving.", "danger");
      return;
    }

    const formData = new FormData();
    formData.append("amount", document.getElementById("account").value);
    formData.append("mode", document.getElementById("account_type").value);
    formData.append("userid", "24");

    try {
      const response = await fetch("https://pro.mokshiq.in/r_transfer", {
        method: "POST",
         headers: {
          'Authorization': `Bearer ${localStorage.getItem("authToken")}`,
        },
        body: formData,
      });
      const result = await response.json();
      if (result.status) {
        showMainToast(result.message || "Success!", "success");
        onClose();
      } else {
        showMainToast(result.message || "Something went wrong!", "danger");
      }
    } catch {
      showMainToast("Something went wrong!", "danger");
    }
  };

  return (
    <BaseModal
      show={show}
      onClose={onClose}
      title={mode === "edit" ? "Edit Account" : "Add Account"}
      footerButtons={[
        { label: "Cancel", className: "btn-secondary", dismiss: true },
        { label: mode === "edit" ? "Update" : "Save", className: "btn-primary", onClick: handleSave },
      ]}
    >
      <div className="card-body">
        <form className="row g-3 app-form rounded-control">
          
          
          {/* Name */}

          <div className="col-md-12">
            <label className="form-label">Amount</label>
            <input
              id="account"
              className={`form-control ${errors.account ? "is-invalid" : ""}`}
              defaultValue={userData?.account || ""}
            />
            {errors.account && <div className="text-danger">{errors.account}</div>}
          </div>

{/* com_type (dropdown from API) */}
<div className="col-md-12">
            <label className="form-label">Payment Mode</label>
            <select
              id="account_type"
              className={`form-select ${errors.account_type ? "is-invalid" : ""}`}
              defaultValue={userData?.account_type || ""}
            >
              <option value="">-- Select Mode --</option>
             
                <option  value="IMPS">
                  IMPS
                </option>
                <option  value="NEFT">
                  NEFT
                </option>
                <option  value="RTGS">
                  RTGS
                </option>
           
            </select>
            {errors.account_type && <div className="text-danger">{errors.account_type}</div>}
          </div>
          


        
        </form>
      </div>
    </BaseModal>
  );
}
